import { useState } from "react";
import { caseSteps } from "@/mocks/dashan";

export default function CaseStudy() {
  const [step, setStep] = useState(0);

  return (
    <section id="case" className="px-4 md:px-6 py-14 md:py-20 bg-background-100/50">
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
        {/* 左侧：图解 */}
        <div className="relative order-2 lg:order-1">
          <div className="rounded-[24px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20editorial%20flat%20illustration%20showing%20a%20conversation%20in%20progress%20at%20a%20cozy%20cafe%2C%20a%20person%20speaking%20with%20a%20thoughtful%20expression%2C%20speech%20bubble%20above%20highlighted%20in%20coral%20red%2C%20cream%20background%20with%20terracotta%20gold%20and%20neutral%20tones%2C%20playful%20yet%20elegant%20vector%20style%2C%20soft%20texture%20and%20warm%20lighting&width=920&height=760&seq=case-breakdown-01&orientation=landscape"
              alt="拆解一场咖啡馆搭讪对话过程的插画"
              className="w-full h-[320px] md:h-[420px] object-cover"
            />
          </div>
          <div className="absolute -bottom-5 right-4 bg-background-50 border border-background-200 rounded-2xl px-4 py-3 shadow-[0_12px_30px_-18px_rgba(0,0,0,0.3)]">
            <p className="text-xs text-foreground-500">本篇拆解</p>
            <p className="text-lg font-heading font-bold text-primary-600">
              +38% <span className="text-xs font-normal text-foreground-600">回复率</span>
            </p>
          </div>
        </div>

        {/* 右侧：步骤切换 */}
        <div className="order-1 lg:order-2">
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
            <i className="ri-scissors-cut-line"></i> 实战拆解
          </span>
          <h3 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            一场聊天，拆开看才知道怎么聊
          </h3>
          <p className="mt-3 text-foreground-600 leading-relaxed">
            把同一句话的「错误版」和「拆解版」并排放在一起，差别一眼可见。点按每一步，看高手是怎么递进节奏的。
          </p>

          <div className="mt-6 flex flex-col gap-3">
            {caseSteps.map((s, i) => (
              <div key={s.title}>
                <button
                  onClick={() => setStep(i)}
                  aria-expanded={step === i}
                  className={`w-full text-left rounded-2xl px-4 py-3.5 flex items-center justify-between cursor-pointer transition-colors ${
                    step === i
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-50 border border-background-200 text-foreground-900 hover:bg-background-200/50"
                  }`}
                >
                  <span className="inline-flex items-center gap-2.5 font-medium">
                    <span
                      className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${
                        step === i
                          ? "bg-background-50 text-primary-600"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {i + 1}
                    </span>
                    {s.title}
                  </span>
                  <i
                    className={`ri-add-line transition-transform ${
                      step === i ? "rotate-45" : ""
                    }`}
                  ></i>
                </button>

                {step === i && (
                  <div className="mt-3 rounded-2xl border border-background-200 bg-background-50 p-4 md:p-5 space-y-3 animate-fadeUp">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-foreground-100 text-foreground-500 text-xs w-fit whitespace-nowrap">
                        <i className="ri-close-circle-line text-foreground-400"></i> 别这样说
                      </span>
                      <p className="text-sm text-foreground-700 leading-relaxed">
                        {s.before}
                      </p>
                    </div>
                    <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 text-xs w-fit whitespace-nowrap">
                        <i className="ri-checkbox-circle-line"></i> 拆解版
                      </span>
                      <p className="text-sm text-foreground-800 leading-relaxed font-medium">
                        {s.after}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}